<template>
  <span class="inline-flex items-center gap-1.5 font-semibold">
    <template v-if="value !== null && label">{{ tr(label) }}</template>
    <span :class="[ 'inline-flex min-w-8 items-center justify-center rounded-md px-1.5 py-0.5 text-sm tabular-nums', toneClasses ]">
      <loader-circle-icon v-if="value === null" class="size-4 animate-spin" />
      <template v-else>{{ value.toFixed(1) }}</template>
    </span>
  </span>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

/** Infinite∞Ai score pill (0–10) with an optional label. */
export default {
  name: 'AiScore',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: () => '',
    },
    value: {
      type: [ Number, null ],
      required: false,
      default: () => null,
    },
  },
  computed: {
    // Red below 5, amber below 7, green from 7.
    toneClasses() {
      if (this.value === null) {
        return 'bg-primary text-primary-foreground';
      }
      if (this.value < 5) {
        return 'bg-destructive text-destructive-foreground';
      }
      if (this.value < 7) {
        return 'bg-warning text-warning-foreground';
      }

      return 'bg-success text-success-foreground';
    },
  },
};
</script>
